import { UnstyledButton } from '@mantine/core';
// icons
import { CircleQuestionMark } from 'lucide-react';
import { ChevronRight } from 'lucide-react';

// components
import { PopoverHint } from '@newo/ui-kit';
// utils
import { cn } from '@/utils';

interface SectionHeadingProps {
    className?: string;
    hint?: React.ReactNode;
    title: string;
    isOpened: boolean;
    onClick?: () => void;
}

const SectionHeading = ({
    className,
    hint,
    title,
    isOpened,
    onClick
}: SectionHeadingProps) => {
    return (
        <UnstyledButton
            className={cn(
                'flex gap-2 items-center w-full p-3 text-xs font-bold uppercase leading-none',
                className
            )}
            onClick={onClick}
        >
            {title}
            {!!hint && (
                <PopoverHint
                    className="text-lg text-gray-6"
                    hint={hint}
                    trigger={<CircleQuestionMark />}
                />
            )}
            <ChevronRight
                className={cn(
                    'relative top-[-1px] text-lg ml-auto transition-rotate duration-250',
                    isOpened && 'rotate-90'
                )}
            />
        </UnstyledButton>
    );
};

export default SectionHeading;
